import clsx from 'clsx';
// components
import { IAct } from '@newo/api/gateway';
import Message from '@/modules/Chat/components/Message';
// utils
import { DATE_FORMAT } from '@/constants';
import { formatDate } from '@/utils/format';
// assets
import styles from '@/modules/Chat/components/UserMessage/UserMessage.module.css';

interface UserMessageProps {
    className?: string;
    act: IAct;
}

const UserMessage = ({ className, act }: UserMessageProps) => {
    return (
        <Message.Root className={clsx(styles.message, className)}>
            <Message.Header
                className={styles.header}
                connectorIdn={act.connector_idn}
                contactInformation={act.contact_information}
                externalId={act.external_id}
                integrationIdn={act.integration_idn}
            />
            <section>{act.original_text}</section>
            <footer className={styles.footer}>
                {formatDate(act.datetime, DATE_FORMAT.FULL_12H)}
            </footer>
        </Message.Root>
    );
};

export default UserMessage;
